if ($('.id--9').length) {
    function customCart() {
        console.log($('.summary-wrapper .price.price-primary').text())
        console.log($('.summary-wrapper .price.price-secondary').text())
        var carContentBox = '<div class="cartContentBox">'
        carContentBox += '<div class="h4">Shrnutí objednávky</div>'
        carContentBox += '<div class="CartLine">'
        carContentBox += '<div class="inner shipping"><span class="title">Dopravné</span><span class="contentLine">Výpočet v dalším kroku</span></div>'
        carContentBox += '<div class="inner "><span class="title">Celkem bez DPH</span><span class="contentLine">' + $('.summary-wrapper .price.price-primary').html() + '</span></div>'
        carContentBox += '<div class="inner "><span class="title">DPH</span><span class="contentLine">' + (parseFloat($(".price-secondary.price").text().replace(/[^\d,.-]/g, "").replace(",", "."))
            - parseFloat($(".price-primary.price").text().replace(/[^\d,.-]/g, "").replace(",", "."))).toFixed(2).replace(".", ",") + ' Kč</span></div>'
        carContentBox += '</div>'
        carContentBox += '</div>'
        $('.summary-wrapper').prepend(carContentBox);
        //   $('.cart-content.summary-wrapper').after('<div class="infoAbout"><a href="' + informaceONakupuLink + '">Informace o nákupu</a></div>');


        $('.price-wrapper .price-label.price-secondary').text('Celkem s DPH');

        var $firstTr = $('tr.removeable:first');
        var tdClasses = [];
        $firstTr.find('td').each(function () {
            var tdClass = $(this).attr('class') || '';
            tdClasses.push(tdClass.trim());
        });
        var $headerRow = $('<tr class="tableHeader"></tr>');
        $.each(groups, function (i, group) {
            var count = 0;
            $.each(group.classes, function (j, cls) {
                $.each(tdClasses, function (k, tdClassString) {
                    var splitClasses = tdClassString.split(' ');
                    if (splitClasses.indexOf(cls) > -1) {
                        count++;
                        return false;
                    }
                });
            });
            var $th = $('<th class="' + group.classes[0] + '"></th>').text(group.name);
            if (count > 1) {
                $th.attr('colspan', count);
            }
            $headerRow.append($th);
        });
        $firstTr.before($headerRow);

        $('.sidebar-in-cart').append($('.extra.delivery'));

    }

    $(document).ready(function () {
        customCart();
    })
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        customCart()
    });
    //$('.cart-inner').before($('ol.cart-header'))




}

if ($('.id--16, .id--17').length) {
    //  $('.cart-inner').before($('ol.cart-header'));
    $('h2.order-icon.order-delivery').text('Výběr dopravy');
    $('h2.order-icon.order-payment').text('Výběr platby');
    $('.order-summary-inner h4').text('Shrnutí objednávky');

    $('.price-wrapper .price-label.price-primary').text('Celkem s DPH');

    $('.order-summary-item.helper>div>strong').text('Cena všech položek bez DPH');
    $('.price-wrapper .price-label.price-secondary').text('Celkem bez DPH');

    $('.price-wrapper').append('<span class="price-label price-secondary dph"> DPH</span>');
    $('.price-wrapper').append('<span class="price price-secondary dph">' + (parseFloat($(".price-primary.price").text().replace(/[^\d,.-]/g, "").replace(",", "."))
        - parseFloat($(".price-secondary.price").text().replace(/[^\d,.-]/g, "").replace(",", "."))).toFixed(2).replace(".", ",") + ' Kč</span>');
}

if ($('.id--17').length) {
   // $('#company-info').addClass('visible');
  //  $('input#company-shopping').trigger('click');
  //  $('input#company-shopping').closest('.company-shopping').hide();
    $('.co-box.co-contact-information').before($('a.login-button').closest('.form-group').addClass('haveLoginButton'))

    $('#checkoutSidebar .cart-content .next-step').before($('.stay-in-touch'));

}

if ($('.id--15').length) {
    $('.orderNumber').append($('.reca-number strong'));
    $('.cart-table tr').each(function () {
        var allprice = parseFloat($(this).find('.p-price').text().replace(',', '.').replace(/ /g, ''))
        var numberPsc = parseFloat($(this).find('.p-quantity').text().split('/')[1].replace(',', '.').replace(/ /g, ''))
        var mathCount = allprice / numberPsc
        $(this).prepend('<td class="psc">' + mathCount + 'x</td>')
    })
}

